<template>
  <div>
    <RomaPoll></RomaPoll>
  </div>
</template>

<script>
import RomaPoll from "@/components/poll/RomaPoll";
import {mapActions, mapGetters} from "vuex";
export default {
  name: "Poll",
  components: {
    RomaPoll,
  },
  mounted() {
    console.log(this.$route.params.e, this.getMa)
    if(this.$route.params.e != this.getMa) {
     // this.toastError({title: "Encuesta incorrecta", message: `Elige una encuesta correcta` });
      this.$router.push({path: `/?i=${this.information.institutionId}&ma=${this.$route.params.e}`})
    }
  },
  computed: {
    ...mapGetters({
      getMa: "getMA",
      information: "getInformation"
    }),
  },
  methods: {
    ...mapActions({
      toastError: "toastError",
    }),
  }
};
</script>

<style scoped></style>
